import axios from "axios";

import { httpClient } from "modules/core/utils/httpClient";
import { removeAuthToken } from "../utils/helpers";
import { authRoutesConstants } from "../routes/routesConstants";

import {
  IAcceptInvitationDto,
  IChangePasswordDto,
  IForgotPasswordDto,
  ILoginDto,
  IResetPasswordDto
} from "../types/dto";
import { ILoginResponse } from "../types/res";

const authHttpClient = (token?: string) =>
  axios.create({
    baseURL: import.meta.env.REACT_APP_API as string,
    headers: {
      Accept: "*/*",
      ...(token
        ? {
            Authorization: token
          }
        : {})
    }
  });

export const login = async (dto: ILoginDto) => {
  const response = await authHttpClient().post<ILoginResponse>(
    "/users/sessions",
    dto
  );

  return response.data;
};

export const changePassword = async ({
  token,
  dto
}: {
  token: string;
  dto: IChangePasswordDto;
}) => {
  const response = await authHttpClient(token).put(
    "/users/update_password",
    dto
  );

  return response.data;
};

export const resetPassword = async (dto: IResetPasswordDto) => {
  const response = await authHttpClient().put("/users/passwords", dto);

  return response.data;
};

export const forgotPassword = async (dto: IForgotPasswordDto) => {
  const response = await authHttpClient().post("/users/passwords", dto);

  return response.data;
};

export const checkResetPasswordToken = async (dto: { token: string }) => {
  const response = await authHttpClient().get("/users/passwords/check_token", {
    params: {
      reset_password_token: dto.token
    }
  });

  return response.data;
};

export const trackLogin = async ({
  token,
  dto
}: {
  token: string;
  dto: { subdomain: string };
}) => {
  const response = await authHttpClient(token).post("/users/track_login", dto);

  return response.data;
};

export const acceptInvitation = async (dto: IAcceptInvitationDto) => {
  const response = await authHttpClient().post<{ token: string }>(
    "/users/accept_invite",
    dto
  );

  return response.data;
};

export const checkInvitationToken = async (dto: { token: string }) => {
  const response = await authHttpClient().get("/users/check_token", {
    params: {
      invitation_token: dto.token
    }
  });

  return response.data;
};

export const logout = async () => {
  try {
    const response = await httpClient.delete("/users/sessions", {
      headers: { Accept: "*/*" }
    });

    removeAuthToken();
    window.location.href = authRoutesConstants.login.href();

    return response.data;
  } catch (error) {
    return null;
  }
};
